import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';

import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import $ from "jquery";
const DecayStockFollowUps = () => {
    const [menu, setMenu] = useState(false);
    // const [data, setData] = useState([]);
    const [dataall, setDataall] = useState([]);
    const [permission, setPermission] = useState({});
    const [dataoverview, setDataoverview] = useState({});
    let season_id = localStorage.getItem("season_id");
    let para ={season_id:season_id};
    useEffect(() => {
          setPermission(FindModuleById(301)); 
          console.log(permission);
    

      axios.post("/helpers/decay-stock-follow-ups-new",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        if(response.data.code === 200){
        
        setDataall(response.data.data.stocks);
        setDataoverview(response.data.data.overview);     
        
      }else{
        console.log("API response is not an array");
      }
              
    })
    .catch((error) => {
      console.log(error);
    });

  }, []);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  
   const calibreCell = ({ row }) => {
    console.log("row");
    console.log(row.original);
    const dateArr = row.original.week.split("_");
    console.log(dateArr); 
    let start_date = dateArr[0];
    let end_date = dateArr[1];
  
     return (
       <a href={`/decay-stock-follow-ups-weekly?start_date=${start_date}&end_date=${end_date}`}>
         {start_date+ ' to '+end_date}
       </a>
     );
   };
    
   // ✅ PropTypes for calibreCell
   calibreCell.propTypes = {
     row: PropTypes.shape({
       original: PropTypes.shape({
        week_name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
       }).isRequired,
     }).isRequired,
   };



   const updateDate = async (id,type) =>{
    //  const showDateInputAlert = async () => {
        const { value: decay_weight } = await  Swal.fire({
          title: 'Add Decay Quantity ',
          html: '<input type="text" id="datePicker" placeholder="Enter Stock" class="swal2-input">',
          showCancelButton: true,
          confirmButtonText: 'Submit',
          cancelButtonText: 'Cancel',
          customClass: "swal-orders",
          preConfirm: () => {
            return document.getElementById('datePicker').value;
          }
        });
       
        if (decay_weight) {
          // Do something with the selected date
          console.log('Selected decay_weight:', decay_weight);
              axios.get(`/decay-stock-follow-ups/update-net-weight/${season_id+'__'+id}/${decay_weight}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
              .then((response) => {
                console.log(response);
                
                if (response.data.code === 200) {
                  $("#button-"+type+"-"+id).text(response.data.data.decay_weight);
                  
                  axios.post("/helpers/decay-stock-follow-ups-new",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
                  .then((response) => {
                    if(response.data.code === 200){
                    
                    setDataall(response.data.data.stocks);
                    setDataoverview(response.data.data.overview);     
                    
                  }else{
                    console.log("API response is not an array");
                  }
                          
                })
                .catch((error) => {
                  console.log(error);
                });
                  Swal.fire(
                    'Success!',
                    'Stock Updated Successfully.',
                    'success'
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              }); 
        }
  
  }
  
    const ProductionDateCell = ({ row, permission, updateDate }) => {
      const { original } = row;
    
      return (
        <div>
          {permission?.update == 1 ? (
            <button
              className="btn btn-primary btn-block"
              id={`button-all-${original.week}`}
              onClick={() => updateDate(original.week, 'all')}
            >
              {original.stock ?? 'Update'}
            </button>
          ) : (
            <span>{original.stock ?? 'N/A'}</span>
          )}
        </div>
      );
    };
    
    
    // ✅ Define PropTypes
    ProductionDateCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          week: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          stock: PropTypes.string,
        }).isRequired,
      }).isRequired,
      permission: PropTypes.shape({
        update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      updateDate: PropTypes.func.isRequired,
    };
  

  const columnsresult =
  [
    {
      header: 'Week',
      accessorKey: 'week',
      Cell: calibreCell,
    },
    {
      header: 'Farm decay Net Weight',
      accessorFn: (row) =>
        typeof row.sum_materials_decay_net_weight === "number"
            ? `${row.sum_materials_decay_net_weight.toFixed(2)} (KG)`
            : "0.00 (KG)",
    },
    {
      header: 'Production Decay Net Weight',
      accessorFn: (row) => {
        return `${Number(row.sum_production_net_weight || 0).toFixed(2)} (KG)`;
    },

   
    },
    {
      header: 'Decay sales Net Weight',
      accessorFn: (row) => {
        return `${Number(row.sum_decalsale_net_weight || 0).toFixed(2)} (KG)`;
    },
  
    },
    {
      header: 'Stock',
      accessorFn: (row) => row.stock || '',
      Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
    },
  
    {
      header: 'Losses',
      accessorFn: (row) => {
        const farmDecay = Number(row.sum_materials_decay_net_weight || 0);
        const productionDecay = Number(row.sum_production_net_weight || 0);
        const decaySales = Number(row.sum_decalsale_net_weight || 0);
        const stock = Number(row.stock || 0);
    
        const losses = ((farmDecay + productionDecay) - decaySales + stock).toFixed(2);
    
        return `${losses} (KG)`;
      },
    },
    
   
    
   ];


  

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Decay Stock Follow Ups</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Decay Stock Follow Ups</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Stock situation</div>
                          <div className="dash-counts">
                          <p>{dataoverview.decay !== undefined ? dataoverview.decay.toFixed(2) : "0.00"}KG</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
              
                      
                </div>

                <div className="row">
                  <div className="col-sm-12">
                  
                    {permission && permission.list == 1 && (
                      <div className="card card-table">
                        <div className="card-body">
                          <div className="table-responsive">
                          <MaterialReactTable columns={columnsresult} data={dataall} 
                            // enableColumnFilterModes
                            enableColumnOrdering
                            // enableGrouping
                            enablePinning
                        
                          />
                          </div>
                        </div>
                      </div>
                    )}

                  
                  </div>
                </div>
        </div>
      </div>
    </div>
  );
};
export default DecayStockFollowUps;
